export const Config = {
    // appUrl: "/addon-technology",
    // apiUrl:"https://ztpl.net/addon-technology/admin/api",
    appUrl:"", //live
    apiUrl:"https://www.addontechno.com/admin/api" //live
}